<template>
  <BButton class="remove-item" variant="danger" @click.prevent="$emit('remove')">
    <span> × </span>
  </BButton>
</template>

<script setup></script>
